export default __webpack_public_path__ + "static/media/user-page-bg.00038b32.jpg";